var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTelegramCircle = function SvgIconTelegramCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconTelegramCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 0c6.628 0 12 5.372 12 12s-5.372 12-12 12-12-5.372-12-12 5.372-12 12-12m4.14 16.891c.22-.677 1.254-7.426 1.382-8.756.039-.403-.089-.67-.338-.79-.302-.145-.748-.072-1.266.114-.71.256-9.795 4.114-10.32 4.337-.498.211-.969.442-.969.776 0 .235.14.367.524.504.4.142 1.406.447 2 .611.572.158 1.224.021 1.59-.206.386-.24 4.854-3.23 5.175-3.492s.576.074.314.336-3.329 3.239-3.733 3.65c-.491.501-.143 1.02.187 1.227a214 214 0 0 1 3.489 2.343c.407.291.82.423 1.199.423.378 0 .577-.498.766-1.077"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconTelegramCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgIconTelegramCircle;